export type SupportRouteModule = typeof import("./support");

let supportRouteModulePromise: Promise<SupportRouteModule> | null = null;

export function prefetchSupportRouteModule(): Promise<SupportRouteModule> {
  supportRouteModulePromise ??= import("./support");
  return supportRouteModulePromise;
}
